export const CREATE_WFH_LEAVE = "CREATE_WFH_LEAVE";
export const FETCH_WFH_LEAVES = "FETCH_WFH_LEAVES";
export const FETCH_WFH_LEAVE = "FETCH_WFH_LEAVE";
export const EDIT_WFH_LEAVE = "EDIT_WFH_LEAVE";
export const DELETE_WFH_LEAVE = "DELETE_WFH_LEAVE";
